import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  alignItems: {
    property: 'alignItems'
  },
  alignContent: {
    property: 'alignContent'
  },
  justifyItems: {
    property: 'justifyItems'
  },
  justifyContent: {
    property: 'justifyContent'
  },
  flexWrap: {
    property: 'flexWrap'
  },
  flexDirection: {
    property: 'flexDirection'
  },
  flex: {
    property: 'flex'
  },
  flexFlow: {
    property: 'flexFlow'
  },
  flexGrow: {
    property: 'flexGrow'
  },
  flexShrink: {
    property: 'flexShrink'
  },
  flexBasis: {
    property: 'flexBasis'
  },
  justifySelf: {
    property: 'justifySelf'
  },
  alignSelf: {
    property: 'alignSelf'
  },
  order: {
    property: 'order'
  },
  placeItems: {
    property: 'placeItems'
  },
  placeContent: {
    property: 'placeContent'
  },
  placeSelf: {
    property: 'placeSelf'
  },
  gap: {
    property: 'gap'
  }
};
const flexbox = system(config);

export { flexbox };
